<template>
  <f7-page no-swipeback ref="page" ptr @ptr:refresh="refresh" @page:afterin="afterIn">
    <f7-navbar title="訂單列表 Order List" back-link="返回 Back">
      <f7-button class="right" @click="toggle">範圍 Range</f7-button>
    </f7-navbar>

    <f7-toolbar tabbar scrollable position="top">
      <f7-link tab-link :tab-link-active="current_status === status.id" :key="status.id" v-for="status in orderStatus" @click="() => filterStatus(status.id)">{{ status.name }}</f7-link>
    </f7-toolbar>

    <f7-list media-list ref="list">
        <f7-list-item
          v-if="is_ranged"
          title="選擇日期"
        >
          <DateRangePicker
            v-model="rangeDate"
            @change="updateDate"
          />
          <div style="position: absolute; top: 50%; right: 1.5rem;">
            <CalendarIcon />
          </div>
        </f7-list-item>

      <f7-list-item
        v-if="(rangeDateData.products && rangeDateData.products.length > 0) && is_ranged"
        title="Date Range Page"
        :after="current_status"
        @click="goToTotalDetailPage"
      >
        <div class="item-subtitle">
          日期範圍 Date Range：
        </div>
        <div class="item-subtitle">{{ selectedFromDate }}<span v-if="selectedFromDate !== selectedToDate"> - {{ selectedToDate }}</span></div>
        <div v-if="rangeDateData.supply_total_quantity !== 0" class="item-text">
          欠 Missing
          {{ current_status === 'Completed' ? (rangeDateData.total_quantity - rangeDateData.completed_supply_total_quantity) : (rangeDateData.total_quantity - rangeDateData.uncompleted_supply_total_quantity) }}
          項 Items
        </div>
        <div class="item-text">合計 Total {{ rangeDateData.total_quantity }} 項 Items</div>
      </f7-list-item>

      <f7-list-item
        v-for="order in is_ranged ? ranged_group : data.data"
        :link="`/warehouse/order/${order.id}/`"
        :key="order.id"
        :title="`#${order.id} - ${order.order_at}`"
        :after="order.status"
        :subtitle="order.description"
      >
        <div class="item-subtitle">
          下單時間 Ordered At：{{ order.created }}
        </div>
        <div class="item-text">{{ order.user_name }}</div>
        <div class="item-text">{{ order.store_name }}</div>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import axios from 'axios'
import { format, parseISO, formatISO } from 'date-fns'

import CalendarIcon from './icons/CalendarIcon'
import DateRangePicker from './DateRangePicker'

export default {
  props: {
    f7route: Object,
  },

  components: {
    CalendarIcon,
    DateRangePicker
  },

  computed: {
    selectedFromDate() {
      return format(parseISO(this.fromDate), 'yyy-MM-dd')
    },
    selectedToDate() {
      return format(parseISO(this.toDate), 'yyyy-MM-dd')
    }
  },

  data() {
    return {
      data: [],
      current_status: 'Pending',
      orderStatus: [
        {id: 'Pending', name: 'Pending 待處理'},
        {id: 'Processing', name: 'Processing 處理中'},
        {id: 'Completed', name: 'Completed 已完成'},
        {id: 'Canceled', name: 'Canceled 已取消'},
      ],
      is_ranged: false,
      ranged_group: [],
      fromDate: '',
      toDate: '',
      rangeDate: {},
      rangeDateData: {},
    }
  },

  methods: {
    afterIn () {
      this.fetchData().then(data => this.data = data)
    },
    fetchData () {
      return new Promise((resolve, reject) => {
        axios.get(`/api/orders?status=${this.current_status}`)
          .then(({ data }) => {
            for (let i = 0; i < data.data.length; i++) {
              data.data[i].order_at = format(parseISO(data.data[i].order_at), 'yyyy-MM-dd')
              data.data[i].description = `${parseFloat(data.data[i].total_quantity)} 件 Items，合共 Total $${(data.data[i].total / 100)}`
              data.data[i].created = `${format(parseISO(data.data[i].created_at), 'yyyy-MM-dd HH:mm')}`
            }
            resolve(this.data = data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    refresh (done) {
      this.fetchData().then(data => {
        this.data = data
        done()
      })
    },
    filterStatus (status) {
      this.current_status = status
      if (this.is_ranged) {
        this.fetchTotalData()
      } else {
        this.fetchData().then(data => this.data = data)
      }
    },
    updateDate (dateRange) {
      if (dateRange.fromDate && dateRange.toDate) {
        this.fromDate = formatISO(new Date(dateRange.fromDate + 'T00:00:00'))
        this.toDate = formatISO(new Date(dateRange.toDate + 'T23:59:59'))

        this.fetchTotalData()
      }
    },
    toggle () {
      this.is_ranged = !this.is_ranged

      this.rangeDateData = {}
      this.fromDate = ''
      this.toDate = ''
    },
    goToTotalDetailPage () {
      this.$f7router.navigate({
        path: '/warehouse/order/range-page/',
        query: {
          fromDate: this.fromDate,
          toDate: this.toDate,
          status: this.current_status
        }
      })

      this.is_ranged = false
    },
    async fetchTotalData() {
      const { data } = await axios.post('/api/orders-summary', {
        filters: { fromDate: this.fromDate, toDate: this.toDate },
        status: this.current_status
      })
      this.rangeDateData = data
    }
  }
}
</script>
